import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import { RichText } from 'prismic-reactjs';
import { Link, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'
import Img from "gatsby-image"


export const query = graphql`
query topicTemplateQuery($uid: String!)  {
  prismic {
    allTopics(uid: $uid) {
      edges {
        node {
          body
          title
        }
      }
    }
    allPosts(tags: [$uid], sortBy: meta_firstPublicationDate_ASC) {
      edges {
        node {
          _meta{
              type
              uid
            }
          title
          timespan
          image
          imageSharp {
            childImageSharp {
              fluid(quality: 100) {
                  ...GatsbyImageSharpFluid
                }
            }
          }
        }
      }
    }
  }
  }
`

export default (props) => {
  const topic = props.data.prismic.allTopics.edges[0];
  if (!topic) return null;
  const posts = props.data.prismic.allPosts.edges;
  if (!posts) return null;
  return (
    <div className="body">
      <Layout>
        <SEO title={topic.node.title[0].text} />
        <div className="grid-child intro">
          <div className="text-wrapper">
            <h1>{topic.node.title[0].text}</h1>
            <p className="page-paragraph">{RichText.render(topic.node.body)}<br /></p>
          </div>
        </div>
        <div className="grid-child nopadding">
          <div className="card-parent grid">
            {posts.map(({ node: post }, i) => (
              <Link to={linkResolver(post._meta)} key={i} className="no-decoration">
                <div className="card ingrid w-inline-block">
                  <div className="card-label">
                    <h4 className="card-title">{post.title[0].text}</h4>
                    <div>{post.timespan[0].text}</div>
                  </div>
                  <div className="card-image">
                    <Img fluid={post.imageSharp.childImageSharp.fluid} className="image" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </Layout>
    </div>
  )
}

